(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tiny-product-preview"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.TinyProductPreview?.initialized) return;

    const transitionDuration = 500;

    const clearPreviewTimers = (preview) => {
      ['previewDialogTimer', 'previewCloseTimer', 'previewHideTimer'].forEach((timerName) => {
        if (!preview.dataset[timerName]) return;

        window.clearTimeout(Number(preview.dataset[timerName]));
        delete preview.dataset[timerName];
      });
    };

    const openPreview = (preview) => {
      if (!preview) return;

      clearPreviewTimers(preview);

      preview.hidden = false;
      preview.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tiny-product-preview-open');
      preview.classList.remove('is-closing', 'is-dialog-open');

      window.requestAnimationFrame(() => {
        if (preview.hidden || preview.classList.contains('is-closing')) return;

        preview.classList.add('is-open');
        preview.dataset.previewDialogTimer = window.setTimeout(() => {
          if (!preview.hidden && !preview.classList.contains('is-closing')) {
            preview.classList.add('is-dialog-open');
          }

          delete preview.dataset.previewDialogTimer;
        }, transitionDuration);
      });
    };

    const closePreview = (preview, afterClose) => {
      if (!preview || preview.hidden) {
        afterClose?.();
        return;
      }

      clearPreviewTimers(preview);

      preview.classList.add('is-closing');
      preview.classList.remove('is-dialog-open');
      document.body.classList.remove('tiny-product-preview-open');

      preview.dataset.previewCloseTimer = window.setTimeout(() => {
        preview.classList.remove('is-open');
        delete preview.dataset.previewCloseTimer;

        preview.dataset.previewHideTimer = window.setTimeout(() => {
          preview.hidden = true;
          preview.setAttribute('aria-hidden', 'true');
          preview.classList.remove('is-closing', 'is-dialog-open');
          delete preview.dataset.previewHideTimer;
          afterClose?.();
        }, transitionDuration);
      }, transitionDuration);
    };

    const addToCart = async ({ formData, button, defaultLabel, onSuccess, preserveContent = false }) => {
      if (!button || button.disabled) return;

      const originalLabel = defaultLabel || button.textContent.trim() || 'Add to cart';
      let failed = false;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (preserveContent) {
        button.setAttribute('aria-label', 'Adding to cart');
      } else {
        button.textContent = 'Adding...';
      }

      try {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        if (!response.ok) throw new Error('Add to cart failed');

        onSuccess?.();
      } catch (error) {
        failed = true;
        if (preserveContent) {
          button.setAttribute('aria-label', 'Unable to add');
        } else {
          button.textContent = 'Unable to add';
        }
        window.setTimeout(() => {
          if (preserveContent) {
            button.setAttribute('aria-label', originalLabel);
          } else {
            button.textContent = originalLabel;
          }
        }, 1800);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (preserveContent && !failed) {
          button.setAttribute('aria-label', originalLabel);
        } else if (button.textContent === 'Adding...') {
          button.textContent = originalLabel;
        }
      }
    };

    const openCartDrawer = () => {
      document.querySelector('[data-cart-drawer]')?.dispatchEvent(new CustomEvent('tiny:cart-drawer:open'));
    };

    const initProductPreviewProduct = (productSection) => {
      const quantityControl = productSection.querySelector('[data-quantity-control]');
      if (quantityControl && quantityControl.dataset.previewInitialized !== 'true') {
        quantityControl.dataset.previewInitialized = 'true';

        const input = quantityControl.querySelector('[data-quantity-input]');
        const minus = quantityControl.querySelector('[data-quantity-minus]');
        const plus = quantityControl.querySelector('[data-quantity-plus]');

        const setValue = (nextValue) => {
          const min = Number(input.min || 1);
          const value = Math.max(min, Number(nextValue) || min);
          input.value = value;
        };

        minus.addEventListener('click', () => setValue(Number(input.value) - 1));
        plus.addEventListener('click', () => setValue(Number(input.value) + 1));
        input.addEventListener('change', () => setValue(input.value));
      }

      if (productSection.dataset.previewGalleryInitialized !== 'true') {
        productSection.dataset.previewGalleryInitialized = 'true';

        const featuredButton = productSection.querySelector('[data-preview-featured]');
        const featuredImage = featuredButton ? featuredButton.querySelector('img') : null;

        productSection.querySelectorAll('[data-preview-gallery-thumb]').forEach((thumb) => {
          thumb.addEventListener('click', () => {
            if (!featuredImage) return;

            featuredImage.src = thumb.dataset.imageUrl;
            featuredImage.removeAttribute('srcset');
            featuredImage.alt = thumb.dataset.imageAlt || '';

            productSection.querySelectorAll('[data-preview-gallery-thumb]').forEach((otherThumb) => {
              otherThumb.classList.toggle('is-active', otherThumb === thumb);
            });
          });
        });
      }

      if (productSection.dataset.previewCartSubmitInitialized !== 'true') {
        productSection.dataset.previewCartSubmitInitialized = 'true';

        const productForm = productSection.querySelector('.tiny-product__form');
        const addButton = productSection.querySelector('[data-add-button]');

        productForm?.addEventListener('submit', async (event) => {
          event.preventDefault();

          if (!addButton || addButton.disabled) return;

          await addToCart({
            formData: new FormData(productForm),
            button: addButton,
            onSuccess: () => {
              const preview = productSection.closest('[data-product-preview]');
              closePreview(preview, openCartDrawer);
            },
          });
        });
      }

      if (productSection.dataset.previewVariantInitialized !== 'true') {
        productSection.dataset.previewVariantInitialized = 'true';

        const variantScript = productSection.querySelector('[data-product-variants]');
        const optionControls = productSection.querySelectorAll('[data-option-control]');
        const variantInput = productSection.querySelector('[data-variant-id]');
        const addButton = productSection.querySelector('[data-add-button]');
        const priceElement = productSection.querySelector('[data-product-price]');

        if (!variantScript || !optionControls.length || !variantInput || !addButton) return;

        const variants = JSON.parse(variantScript.textContent);
        const currency = productSection.dataset.currency || 'USD';
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          currencyDisplay: 'code',
        });

        const formatMoney = (value) => formatter.format((Number(value) || 0) / 100);

        const getSelectedOptions = () => {
          const selected = [];

          optionControls.forEach((control) => {
            const position = Number(control.dataset.optionPosition) - 1;

            if (control.type === 'radio' && !control.checked) return;

            selected[position] = control.value;
          });

          return selected;
        };

        const updateSelectedLabels = (selectedOptions) => {
          productSection.querySelectorAll('[data-option-selected]').forEach((label) => {
            const position = Number(label.dataset.optionSelected) - 1;
            label.textContent = selectedOptions[position] || '';
          });
        };

        const syncVariant = () => {
          const selectedOptions = getSelectedOptions();
          const selectedVariant = variants.find((variant) => (
            variant.options.every((option, index) => option === selectedOptions[index])
          ));

          updateSelectedLabels(selectedOptions);

          if (!selectedVariant) {
            addButton.disabled = true;
            addButton.textContent = 'Unavailable';
            return;
          }

          variantInput.value = selectedVariant.id;
          addButton.disabled = !selectedVariant.available;
          addButton.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';

          if (priceElement) {
            priceElement.textContent = selectedVariant.price_formatted || formatMoney(selectedVariant.price);
          }
        };

        optionControls.forEach((control) => control.addEventListener('change', syncVariant));
        syncVariant();
      }
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-tiny-product-preview-product]').forEach(initProductPreviewProduct);

      root.querySelectorAll('[data-product-preview-open], [data-product-quick-add]').forEach((button) => {
        if (button.dataset.productPreviewInitialized === 'true') return;
        button.dataset.productPreviewInitialized = 'true';

        button.addEventListener('click', () => {
          const quickAddVariantId = button.dataset.productQuickAdd;

          if (quickAddVariantId) {
            const formData = new FormData();
            formData.append('id', quickAddVariantId);
            formData.append('quantity', '1');

            addToCart({
              formData,
              button,
              defaultLabel: button.getAttribute('aria-label') || 'Add to cart',
              preserveContent: true,
              onSuccess: openCartDrawer,
            });
            return;
          }

          const preview = document.getElementById(button.dataset.productPreviewOpen);
          if (!preview) return;

          openPreview(preview);

          const dialog = preview.querySelector('.tiny-product-preview__dialog');
          dialog?.focus({ preventScroll: true });
        });
      });

      root.querySelectorAll('[data-product-preview]').forEach((preview) => {
        if (preview.dataset.productPreviewInitialized === 'true') return;
        preview.dataset.productPreviewInitialized = 'true';

        preview.querySelectorAll('[data-product-preview-close]').forEach((button) => {
          button.addEventListener('click', () => closePreview(preview));
        });
      });
    };

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('[data-product-preview]:not([hidden])').forEach((preview) => {
        closePreview(preview);
      });
    });

    window.TinyProductPreview = { initialized: true, init };
    init();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
